"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			toastOptions={{
				classNames: {
					toast:
						"group toast group-[.toaster]:bg-primary group-[.toaster]:text-primary group-[.toaster]:border-secondary group-[.toaster]:shadow-lg",
					description: "group-[.toast]:text-tertiary",
					actionButton:
						"group-[.toast]:bg-brand-solid group-[.toast]:text-white",
					cancelButton:
						"group-[.toast]:bg-secondary group-[.toast]:text-tertiary",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster, toast };
